import Configure from '@/plugins/dashboard/widgets/Base/Configure'

export default function createConfigure (definition) {
  return {
    name: `${definition.name.replace(/\s/g, '')}Configure`,
    props: {
      widget: {
        type: Object,
        default: () => ({})
      }
    },
    methods: {
      submit () {
        this.$refs.configure.submit()
      }
    },
    render (createElement) {
      return createElement(Configure, {
        ref: 'configure',
        props: {
          definition,
          widget: this.widget
        },
        on: {
          submitted: widget => this.$emit('submitted', widget)
        }
      })
    }
  }
}
